(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const badge = document.querySelector('[data-discount-badge]');
    
    if (!badge) return;
    
    const discountText = badge.querySelector('[data-discount-text]');
    const variants = JSON.parse(badge.getAttribute('data-variants'));
    const initialVariantId = parseInt(badge.getAttribute('data-current-variant'));
    
    function updateDiscountBadge(variantId) {
      const variant = variants.find(v => v.id == variantId);
      
      if (!variant) return;
      
      const comparePrice = variant.compare_at_price;
      const price = variant.price;
      
      if (comparePrice && comparePrice > price) {
        const discount = Math.round(((comparePrice - price) * 100) / comparePrice);
        discountText.textContent = discount + '% DTO.';
        badge.classList.add('show');
      } else {
        badge.classList.remove('show');
        discountText.textContent = '';
      }
    }
    
    // Inicializar
    updateDiscountBadge(initialVariantId);
    
    // Escuchar cambios en select
    const variantSelects = document.querySelectorAll('select[name="id"]');
    variantSelects.forEach(selector => {
      selector.addEventListener('change', function(e) {
        updateDiscountBadge(parseInt(e.target.value));
      });
    });
    
    // Escuchar cambios en radio buttons / inputs
    const variantInputs = document.querySelectorAll('input[name="id"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', function(e) {
        updateDiscountBadge(parseInt(e.target.value));
      });
    });
    
    // Observar cambios en la URL
    let lastVariantId = initialVariantId;
    setInterval(function() {
      const urlParams = new URLSearchParams(window.location.search);
      const currentVariantId = urlParams.get('variant');
      
      if (currentVariantId && parseInt(currentVariantId) !== lastVariantId) {
        lastVariantId = parseInt(currentVariantId);
        updateDiscountBadge(lastVariantId);
      }
    }, 300);
    
    // Escuchar clicks en botones de variante
    document.addEventListener('click', function(e) {
      const variantButton = e.target.closest('[data-variant-id]');
      if (variantButton) {
        const variantId = parseInt(variantButton.getAttribute('data-variant-id'));
        setTimeout(() => updateDiscountBadge(variantId), 100);
      }
    });
  });
})();